const waterLevelStatusColor = [
  {
    label: 'ไม่มีข้อมูล',
    rangeTitle: 'ข้อมูลไม่เพียงพอ',
    statusColor: '#BDBDBD',
    constrastColor: '#000',
    fontSize: '12px',
    level: 0,
  },
  {
    label: 'น้อยวิกฤต',
    rangeTitle: '<=10',
    statusColor: '#db802b',
    constrastColor: '#000',
    fontSize: '12px',
    level: 1,
  },
  {
    label: 'น้อย',
    rangeTitle: '>10-30',
    statusColor: '#ffc000',
    constrastColor: '#000',
    fontSize: '12px',
    level: 2,
  },
  {
    label: 'ปกติ',
    rangeTitle: '>30-70',
    statusColor: '#00b050',
    constrastColor: '#000',
    fontSize: '12px',
    level: 3,
  },
  {
    label: 'มาก',
    rangeTitle: '>70-100',
    statusColor: '#003cfa',
    constrastColor: '#fff',
    fontSize: '12px',
    level: 4,
  },
  {
    label: 'ล้นตลิ่ง',
    rangeTitle: '>100',
    statusColor: '#ff0000',
    constrastColor: '#fff',
    fontSize: '12px',
    level: 5,
  },
];

export default waterLevelStatusColor;
